module.exports = __webpack_public_path__ + "static/media/privateGroupIcon.aceac38e.svg";